import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";
import { useParcelEditContext } from "./parcel-edit-context";

export const ParcelEditSelect = memo(function ParcelEditSelect() {
  const context = useParcelEditContext();

  if (!context) {
    return null;
  }

  const { parcelsLength, parcelBeingEditedIndex, setParcelBeingEditedIndex } =
    context;

  if (parcelsLength <= 1) {
    return null;
  }

  const items = Array.from({ length: parcelsLength }, (_, index) => ({
    id: index.toString(),
    text: `Parcel ${index + 1}`,
    value: index.toString(),
    type: "text" as const,
  }));

  const selectedItem = items.find(
    (item) => item.value === parcelBeingEditedIndex.toString(),
  );
  return (
    <RedoSingleSelectDropdownInput
      options={items}
      optionSelected={(args) => setParcelBeingEditedIndex(args.index)}
      selectedItem={selectedItem}
    />
  );
});
